module.exports = __webpack_public_path__ + "static/colors-content-nonessential-dont-6be6579a5b7d9fe675a35613e8747502.png";